/* global PCHUSER, PCH */
import $ from "vendor/zepto";
import UserService from "keno/app/services/User";
import animUtil from "keno/app/modules/animationUtil";
import EventsMixin from "keno/app/mixins/events";

const SSOLightboxView = function() {};

Object.assign(SSOLightboxView.prototype, EventsMixin, {
	EVENTS: {
		SSO_LIGHTBOX_SUBMIT: `SSOLightboxSubmit`,
		SSO_NO_THANKS: `noThanks`
	},
	init: function() {},
	mount: function() {
		// console.log( `sso lightbox mount` );
		this.rootNode = $(`.sso-create-password-lightbox-modal`);
		this.submitButton = this.rootNode.find(
			`#sso-create-password-lightbox__submit-button`
		);
		this.passwordField = this.rootNode.find(
			`#sso-create-password-lightbox-create-password`
		);
		this.confirmPasswordField = this.rootNode.find(
			`#sso-create-password-lightbox-confirm-password`
		);

		this.submitButton.on(`click`, this.onSubmit.bind(this));

		this.errorContainer = this.rootNode.find(`#sso-lightbox-error-container`);
		this.errorInnerShell = this.errorContainer.find(`.inner-shell`);
		this.errorHeaderText = this.errorContainer.find(`#sso-header-text`);
		this.headerText = this.rootNode.find(`.sso-lightbox-header-text`);
		this.bodyText = this.rootNode.find(`.create-password`);

		if (window.isMobile) {
			this.mobileErrorContainer = $(`#notey`);
			this.errorHeaderText = $(`#notey .message`);
			this.errorOuterShell = $(`.sso-outer-shell`);
			this.errorInnerShell = this.errorOuterShell.find(`.inner-shell`);
		} else {
			this.errorContainer = $(`#sso-lightbox-error-container`);
			this.errorHeaderText = this.errorContainer.find(`#sso-header-text`);
			this.errorOuterShell = $(`.sso-outer-shell`);
			this.errorInnerShell = this.errorOuterShell.find(`.inner-shell`);
		}

		this.firstName = this.rootNode.find(`#sso-lightbox-first-name`);
		this.firstName.html(PCHUSER.firstName);
		this.noThanks = this.rootNode.find(`.no-thanks`);
		this.modalBodyLink = this.rootNode.find(`#modal-body__link-text`);
		this.modalBodySubmit = this.rootNode.find(`#modal-body__submit-text`);

		this.closeButton = this.rootNode.find(`.close`);
		this.fromLink = false;
		this.fromGameSubmit = false;

		this.noThanks.on(
			`click`,
			function(e) {
				e.preventDefault();
				this.fromLink = true;
				this.fireEvent(this.EVENTS.SSO_NO_THANKS);
				this.hide();
			}.bind(this)
		);

		this.closeButton.on(
			`click`,
			function() {
				this.fireEvent(this.EVENTS.SSO_NO_THANKS);
				this.hide();
			}.bind(this)
		);

		//B-65352 - TK-240446 - Lightbox should disappear when user clicks outside
		this.clickHandler = function clickHandler(event) {
			//return if the lightbox is not visible
			// if ( !this.rootNode.is( `:visible` )) {
			// 	return true;
			// }

			//If the user clicks inside the lightbox, exit
			if (event.target.closest(`.modal-content`)) {
				return true;
			}

			//Hide the lightbox if the user clicked outside it
			this.hide();
			this.fireEvent(this.EVENTS.SSO_NO_THANKS);
			return false;
		}.bind(this);
	},
	unmount: function() {
		if (this.submitButton) {
			this.submitButton.off(`click`);
		}
		this.rootNode = null;
		this.submitButton = null;
		this.passwordField = null;
		this.confirmPasswordField = null;

		this.errorContainer = null;
		this.errorInnerShell = null;
		this.errorHeaderText = null;
		this.firstName = null;

		this.noThanks = null;
		this.modalBodyLink = null;
		this.modalBodySubmit = null;
		this.closeButton = null;
	},
	show: function() {
		this.errorContainer.hide();
		$(`.sso-create-password-lightbox-modal`)
			.appendTo(document.body)
			.modal({
				backdrop: true
			});
	},
	showLink: function() {
		this.headerText.html(
			`Smart Move, <span id = "sso-lightbox-first-name">${
				PCHUSER.firstName
			}</span>!`
		);

		this.noThanks.html(`No, thanks.  I want to forfeit my tokens.`);
		this.bodyText.html(
			`Create a password now and get <span class="tokens">1000 Bonus Tokens!</span>`
		);
		this.modalBodySubmit.hide();
		this.modalBodyLink.show();
		this.fromLink = true;
		this.noThanks.show();
		this.closeButton.show();
		this.show();
	},
	showResults: function() {
		this.headerText.html(`Don't Lose Out.`);
		this.noThanks.html(`No, thanks.  I want to forfeit my tokens.`);
		this.bodyText.html(
			`Create a password now and get <span class="tokens">1000 Bonus Tokens!</span>`
		);
		this.modalBodySubmit.hide();
		this.modalBodyLink.show();
		this.noThanks.show();
		this.closeButton.show();
		this.show();
	},
	showSubmit: function() {
		this.headerText.html(
			`Smart Move, <span id = "sso-lightbox-first-name">${
				PCHUSER.firstName
			}</span>!`
		);

		this.noThanks.html(`No, thanks.  I want to forfeit my tokens.`);
		this.bodyText.html(
			`Create a password now and get <span class="tokens">1000 Bonus Tokens!</span>`
		);
		this.modalBodyLink.show();
		this.modalBodySubmit.hide();
		this.fromSubmit = true;
		this.noThanks.show();
		this.closeButton.show();
		$(`.sso-create-password-lightbox-modal`)
			.appendTo(document.body)
			.modal({
				backdrop: `static`
			});
		//We are using a timeout to set the click handler because this code runs in the context of a click handler.
		//Without the timeout, it will handle the current click...

		setTimeout(
			function() {
				document.addEventListener(`click`, this.clickHandler);
			}.bind(this),
			500
		);
	},
	hide: function() {
		document.removeEventListener(`click`, this.clickHandler);
		this.hideErrorContainer();
		this.passwordField.removeClass(`invalid`).val(``);
		this.confirmPasswordField.removeClass(`invalid`).val(``);
		$(`.sso-create-password-lightbox-modal`).modal(`hide`);
		if (window.isMobile) {
			this.mobileErrorContainer.hide();
		}
	},
	onNoPasswordSuccessCallBack() {
		this.fireEvent(this.EVENTS.SSO_LIGHTBOX_SUBMIT);
	},
	onSubmit: function(e) {
		e.preventDefault();

		// console.log( `sso lightbox on submit` );

		if (this.validateFields()) {
			var obj = new Object();
			let self = this;
			obj.createPasswordController = Object.create(window.PCH.SSO.Controller);
			obj.onSuccessCallBack = this.onNoPasswordSuccessCallBack.bind(this);
			//Register Controller
			//clearing all errors manually since SSOlib isn't doing it for some reason
			// $(".sso-outer-shell").remove();
			obj.createPasswordController.init({
				//var controller = new PCH.SSO.Controller({
				elements: {
					container: $(".sso-create-password-lightbox-modal .modal-content"),
					password: $("#sso-create-password-lightbox-create-password"),
					confirmPassword: $("#sso-create-password-lightbox-confirm-password")
				},
				proxy: {
					createPassword: function(json) {
						//set flag to say password creation is going on

						obj.createPasswordController.showLoaderGraphic(true);

						//var reqObj = {Password:password, ConfirmPassword:confirmPassword, Persist:persist};
						var req = { obj: JSON.stringify(json) };
						//var req = json;
						//var req = Object.assign({}, json);
						//req._token = PCHSSOLightbox.getCsrfToken();
						//req = {obj:JSON.stringify(req)};
						jQuery.ajax({
							type: "GET",
							url:
								secure_url +
								PCHMINIBOOTSTRAP.ssouserBaseURL +
								"/ssoproxy/createpassword",
							contentType: "application/json; charset=utf-8",
							dataType: "jsonp",
							data: req,
							jsonpCallback: "cor",
							success: function(data) {
								obj.createPasswordController.showLoaderGraphic(false);
								obj.successCallBack(data);
							}
						});
					},
					redirect: function(url) {
						if (typeof url !== "undefined") {
							window.location.href = url;
						}
						return false;
					}
				},
				ui: PCH.ssoui,
				success: function() {
					if (typeof obj.onSuccessCallBack === "function") {
						obj.onSuccessCallBack();
					}
				},
				failure: function() {
					PCHSSOProxy.createPasswordInProgress = false;
					obj.createPasswordController.showLoaderGraphic(false);
					if (
						obj.createPasswordController._elements.container.hasClass("da-box")
					) {
						PCHSSOProxy.setButtonStatus(
							obj.createPasswordController._elements.container.find(
								"button.submit"
							),
							1
						);
					} else if (
						obj.createPasswordController._elements.container.find(
							".play_more_button"
						).length != 0
					) {
						$(".play_more_button").removeClass("disabled");
					}
				},
				env: PCH.env
			});
			obj.successCallBack = function(json) {
				if (typeof json.result === "undefined") {
					var response = json.ValidationResponses;
					obj.createPasswordController.onCreatePassword(response);
					if (
						window.isMobile &&
						response.FieldOrDatabaseValidationResponse.Responses
					) {
						self.showErrors(
							response.FieldOrDatabaseValidationResponse.Responses
						);
					}
				} else {
					PCHSSOProxy.createPasswordInProgress = false; //lets give the user the option to try again
				}
			};

			obj.createPasswordController.createPassword();

			// const userService = new UserService();
			//pass password values from form

			// userService.createPassword(
			// 	this.passwordField.val(),
			// 	this.confirmPasswordField.val(),
			// 	(err, resp) => {
			// 		if (err) {
			// 			this.populateErrorResponses(null);
			// 			return false;
			// 		} else if (resp.isValid) {
			// 			if (this.fromSubmit) {
			// 				// console.log( `sso lightbox view - valid response - fire event!` );
			// 				PCHUSER.type = 2; //user is registered now, can show token toasts
			// 				this.fireEvent(this.EVENTS.SSO_LIGHTBOX_SUBMIT);
			// 			} else if (this.fromLink) {
			// 				this.fireEvent(this.EVENTS.SSO_LIGHTBOX_SUBMIT);
			// 			} else {
			// 				sessionStorage.setItem(`showLastActivity`, `true`);
			// 				window.location.reload();
			// 			}
			// 		} else {
			// 			this.showErrors(resp.errorResponses);
			// 			return false;
			// 		}
			// 	}
			// );
		}
	},
	showErrors: function(errorResponses) {
		this.errorHeaderText.html(`Please correct Below and Re-Submit: `);
		//this.positionErrorContainer();
		this.populateErrorResponses(errorResponses);
	},
	validateFields: function() {
		let valid = true;
		let errorHTML = ``;

		if (this.passwordField.val() === ``) {
			this.passwordField.addClass(`invalid`);
			errorHTML += `<div class="error">Password</div>`;
			valid = false;
		}
		if (this.confirmPasswordField.val() === ``) {
			this.confirmPasswordField.addClass(`invalid`);
			errorHTML += `<div class="error">Password Confirmation</div>`;
			valid = false;
		}

		if (!valid) {
			this.errorHeaderText.html(`Please Fill in the Following Fields:`);
			this.errorInnerShell.html(errorHTML);
			this.positionErrorContainer();
			this.showErrorContainer();
		}
		return valid;
	},
	positionErrorContainer: function() {
		const offsetTop = this.confirmPasswordField.position().top;

		this.errorContainer.css(`top`, offsetTop);
	},
	showErrorContainer: function() {
		if (window.isMobile) {
			this.mobileErrorContainer.show();
			this.errorHeaderText.css(`opacity`, 1);
			this.errorOuterShell.show();
			this.errorContainer.show();
			animUtil.animateFast(
				this.errorContainer,
				animUtil.ANIMS.FADE_IN,
				function() {},
				true
			);
		} else {
			this.errorContainer.show();
			animUtil.animateFast(
				this.errorContainer,
				animUtil.ANIMS.FADE_IN,
				function() {},
				true
			);
		}
	},
	hideErrorContainer: function() {
		$(".sso-outer-shell").fadeOut();
		this.errorContainer.hide();

		animUtil.animateFast(
			this.errorContainer,
			animUtil.ANIMS.FADE_OUT,
			() => {},
			true
		);
	},
	populateErrorResponses(errorResponses) {
		let errorHTML = ``;

		if (errorResponses) {
			errorResponses.forEach(function(errorResponse) {
				errorHTML += `<div class="error">` + errorResponse.Message + `</div>`;
			});
		} else {
			errorHTML = `<div class="error">Technical Difficulty - Please Try Again</div>`;
		}

		this.errorInnerShell.html(errorHTML);
		this.positionErrorContainer();
		this.showErrorContainer();
	},
	showSubmitNumbersLightbox() {
		$(`.sso-create-password-lightbox-modal`)
			.appendTo(document.body)
			.modal({
				backdrop: `static`
			});
		//We are using a timeout to set the click handler because this code runs in the context of a click handler.
		//Without the timeout, it will handle the current click...

		setTimeout(
			function() {
				document.addEventListener(`click`, this.clickHandler);
			}.bind(this),
			500
		);

		this.headerText.html(`Warning`);
		this.noThanks.html(`No thanks, I want to skip`);
		this.bodyText.html(
			`Create a password to submit your numbers now.  Don't risk missing out on prize funds.`
		);
		this.modalBodyLink.show();
		this.modalBodySubmit.hide();
		this.fromSubmit = true;
		this.show();
	}
});

export default SSOLightboxView;
